import AuthForm from '../../../../src/js/components/AuthForm';

class TwoFactorForm extends AuthForm {}

document.addEventListener('DOMContentLoaded', () => {
	new TwoFactorForm('.form-user--two-factor');
});
